const CART_ITEMS_ADDED_EVENT = 'cart-items-added';
const cartEvents = new EventTarget();

export const notifyCartItemsAdded = () => {
  cartEvents.dispatchEvent(new Event(CART_ITEMS_ADDED_EVENT));
};

export const subscribeToCartItemsAdded = (listener: () => void) => {
  cartEvents.addEventListener(CART_ITEMS_ADDED_EVENT, listener);

  return () => cartEvents.removeEventListener(CART_ITEMS_ADDED_EVENT, listener);
};
